import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Icons } from '@shopline/dashboard-ui'
import AccordionDropdownPanel from './AccordionDropdownPanel'

const StyledAccordionSelectWrapper = styled.div`
  position: relative;
`

const StyledSelectButton = styled.button`
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 0 12px;
  cursor: pointer;
  outline: none;
  border: 1px solid #d3dde6;
  border-radius: 6px;
  box-sizing: border-box;

  svg {
    fill: #7a8499;
  }

  span {
    color: #7a8499;
  }
`

const StyledDropdownPanelWrapper = styled.div`
  margin-top: 4px;
  width: 245px;
  position: absolute;
  top: 36px;
  right: 0;
  z-index: 50;

  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`

const StyledChevronDiv = styled.div`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
`

const AccordionSelect = ({ onCategoryChange, categories }) => {
  const { t } = useTranslation()
  const [isOpenCategories, setIsOpenCategories] = useState(false)
  const [isSelectedAll, setIsSelectedAll] = useState(true)

  const handleCategoriesChange = (categories) => {
    setIsSelectedAll(categories.length === 0)
    onCategoryChange(categories)
  }

  return (
    <StyledAccordionSelectWrapper>
      <StyledSelectButton onClick={() => setIsOpenCategories(!isOpenCategories)}>
        <Icons.Outline.Filter size="MEDIUM" />
        <span className="mx-2">{isSelectedAll ? t('selectCategory') : t('selectedCategory')}</span>
        <StyledChevronDiv isOpen={isOpenCategories}>
          <Icons.Outline.Chevron size="MEDIUM" />
        </StyledChevronDiv>
      </StyledSelectButton>

      <StyledDropdownPanelWrapper isOpen={isOpenCategories}>
        <AccordionDropdownPanel onCategoryChange={handleCategoriesChange} categories={categories} />
      </StyledDropdownPanelWrapper>
    </StyledAccordionSelectWrapper>
  )
}

AccordionSelect.propTypes = {
  onCategoryChange: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
}

AccordionSelect.defaultProps = {
  onCategoryChange: () => {},
  categories: [],
}

export default AccordionSelect
